// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9upgC","col":"styles_col__2EJzC"};